import deepCopy from 'deepcopy';
import { getGoodsTypesRequest, updateGoodsTypeRequest } from '../requests';
import { throttle, goodsTypesIcons } from '@/core';
import rdbClient from 'rdb-client';

async function getGoodsTypes({ state, commit }) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (state.goodsTypes.length === 0) {
			await fetchGoodsTypes();
		} else {
			await throttle(fetchGoodsTypes, 'fetchGoodsTypes', 60 * 1000);
		}
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchGoodsTypes() {
		let response = await getGoodsTypesRequest();
		response.forEach(goodsType => { goodsType.icon = goodsTypesIcons(goodsType); });
		commit('setGoodsTypes', response);
	}
}

async function setGoodsTypesIcon({ commit }, { goodsType, iconId }) {
	if (goodsType.iconId === iconId) return;
	let goodsTypeClone = deepCopy(goodsType);
	try {
		goodsType.iconId = iconId;
		let patch = rdbClient.createPatch(goodsTypeClone, goodsType);
		await updateGoodsTypeRequest(goodsType.id, { patch });
	} catch (err) {
		commit('set', () => { goodsType.iconId = goodsTypeClone.iconId; });
		throw new Error('failedToUpdate');
	}
}

export default {
	getGoodsTypes,
	setGoodsTypesIcon
};
